/* eslint-disable import/no-cycle */
import axios from 'axios';
import { get } from 'lodash-es';
import { handleApi, handleOdinApi, handleSessionLessApi } from '../common';
import { COMMON } from '../../strings/common';

export const placeOneTimeOrder = async (payload, OdinApi, token = '') => {
	const response = await OdinApi.post(
		API_ENDPOINTS.placeOneTimeOrder,
		payload,
		{},
		token,
	);
	const result = handleOdinApi(response);

	return result;
};

export const placeSipOrder = async (payload, token = '', OdinApi) => {
	const response = await OdinApi.post(
		API_ENDPOINTS.placeSipOrder,
		payload,
		{},
		token,
	);
	const result = handleOdinApi(response);

	return result;
};

export const getMarginInfo = async (payload = {}, token = '', OdinApi) => {
	const response = await OdinApi.post(
		API_ENDPOINTS.getMarginInfo,
		payload,
		{},
		token,
	);
	const result = handleOdinApi(response);
	if (axios.isCancel(result)) {
		throw COMMON.ApiCancelled;
	}

	return result;
};

export const modify_oneTime_order = async (
	exchange,
	orderID,
	payload,
	token = '',
	OdinApi,
) => {
	const response = await OdinApi.put(
		API_ENDPOINTS.modifyOneTimeOrder(exchange, orderID),
		payload,
		{},
		token,
	);
	const result = handleOdinApi(response);
	return result;
};

export const fetch_order_scrip_data = async (payload, token = '', Api) => {
	const url = API_ENDPOINTS.orderFormScripData;
	const response = await Api.post(url, payload);
	const result = handleSessionLessApi(response);
	return result;
};

export const fetch_brokerage_charges = async(Api, payload) => {
	const url = API_ENDPOINTS.calculateBrokerageCharges;
	const response = await Api.post(url, payload);
	const result = handleApi(response);
	return result;
}

const API_ENDPOINTS = {
	placeOneTimeOrder: '/transactional/v1/orders/regular',
	placeSipOrder: '/transactional/v1/orders/eqsip',
	getMarginInfo: '/transactional/v1/getOrderMarginInfo',
	modifyOneTimeOrder: (exchange, orderID) =>
		`transactional/v1/orders/regular/${exchange}/${orderID}`,
	fetchOrderScripData: '/api/equity/api/order_form/data',
	orderFormScripData: '/orderform/data',
	calculateBrokerageCharges: '/api/equity/api/eqm/orders/brokerage/charges/calculate',
};
